import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ButtonToggleComponent {
  @Input() public buttons: any[] = [];
  @Input() public isFullWidth: boolean = false;
  @Input() public isMobile: boolean = false;
  @Input() public disabled: boolean = false;

  @Output() public buttonToggled = new EventEmitter<any>();

  public get selectedButtonId(): any {
    const selectedButton = this.buttons.find(button => button.selected);
    return selectedButton ? selectedButton.id : null;
  }
}
